import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

import './Block.css'

class Block extends PureComponent {
  render() {
    const { children, className, style } = this.props

    return (
      <div className={cn('Block', className)} style={style}>
        {children}
      </div>
    )
  }
}

Block.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Block
